'use client';
import {type EventCategory} from '#/cms/schemas/event-category.schema';
import {type Event} from '#/cms/schemas/event.schema';
import {Map, type MapProps} from '#/features/components/Map';
import {latLngToGoogleLatLngLiteral} from '#/utils/geo';
import {useMemo, useState} from 'react';
import {EventMapMarker} from './EventMapMarker';

type Props = Pick<MapProps, 'searchRadius'> & {
  events: Event[];
  eventCategories: EventCategory[];
};

/**
 * Displays a map with event markers and a search radius if provided.
 */
export const EventsMap = (props: Props) => {
  const {events, eventCategories, searchRadius} = props;
  const mapEvents = useMemo(() => events.filter(event => event.showOnMap && event.coordinate), [events]);
  const boundsLatLngs = useMemo(
    () =>
      mapEvents
        .map(event => (event.coordinate ? latLngToGoogleLatLngLiteral(event.coordinate) : undefined))
        .filter((position): position is google.maps.LatLngLiteral => !!position),
    [mapEvents]
  );
  const [selectedEvent, setSelectedEvent] = useState<string | null>(null);
  return (
    <Map
      boundsLatLngs={boundsLatLngs}
      Markers={
        <>
          {mapEvents.map(event => {
            return (
              <EventMapMarker
                showInfo={selectedEvent ? selectedEvent === event.id : false}
                setShowInfo={setSelectedEvent}
                key={event.id}
                event={event}
                eventCategories={eventCategories}
              />
            );
          })}
        </>
      }
      searchRadius={searchRadius}
    />
  );
};
